import React from 'react';
import { Box, Typography, Button, Container, Grid } from '@mui/material';


const HeroSection = () => {
  
  return (
    <Box
      sx={{
        position: 'relative',
        bgcolor: '#000000',
        color: '#ffffff',
        minHeight: '50vh',
        overflow: 'hidden', // Ensure the circle stays within bounds
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Circular gradient overlay */} 
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '150vh',
          height: '150vh',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(250, 211, 46, 0.2) 0%, rgba(0, 0, 0, 0) 70%)',
          opacity: 0.8,
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
        <Grid container direction="column" alignItems="center" spacing={4}>
          <Grid item>
            <Typography
              variant="h3"
              align="center"
              sx={{
                fontWeight: 'medium',
                fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                color: 'rgba(255, 255, 255, 0.9)',
              }}
            >
              <Box component="span" sx={{ color: '#fad32e' }}>Security-first.</Box>{' '}
              <Box component="span" sx={{ color: '#a1a1aa' }}>Automation-driven.</Box>{' '}
              <Box component="span" sx={{ color: '#ffffff' }}>Built for speed.</Box>
            </Typography>
          </Grid>
          
          <Grid item>
            <Typography
              variant="body1"
              align="center"
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                maxWidth: '600px',
                mx: 'auto',
                fontSize: { xs: '0.9rem', md: '1rem' },
              }}
            >
              Welcome to the DevOps experience your team deserves.
            </Typography>
          </Grid>
          
          <Grid item sx={{ mt: 4, zIndex: 5 }}>
            <Button
              variant="contained"
              sx={{
                pointerEvents:'auto',
                bgcolor: 'rgba(250, 211, 46, 0.1)',
                color: '#fad32e',
                borderRadius: '30px',
                px: 4,
                py: 1,
                textTransform: 'none',
                border: '1px solid rgba(250, 211, 46, 0.3)',
                '&:hover': {
                  bgcolor: 'rgba(250, 211, 46, 0.2)',
                },
                fontSize: '0.9rem',
              }}
              onClick={() => {
                console.log("Button clicked");
                window.open("https://calendly.com/clockhash/talk-to-us", "_blank");
              }}
            >
              Get Started
            </Button>
          </Grid>
        </Grid>
      </Container>

      {/* Circle clip effect - creates a subtle vignette */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at center, transparent 30%, rgba(0,0,0,0.8) 100%)',
          zIndex: 0,
        }}
      />
    </Box>
  );
};

export default HeroSection;